import RevokeUserInterface from "@app/Interface/RevokeUserInterface";

export default class RevokeUserModel implements RevokeUserInterface {
    userId: number;
    fpuId: number;
    
    constructor() {
        this.userId = 0;
        this.fpuId = 0;
    }
}